import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ThirdSectionStore from './store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import { px2rem } from '@src/utils/rem-util';

const styles = require('./index.less');

/**
 * SecondSection
 * @param store {ThirdSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const ThirdSection = ({ store }) => {
  store.use();

  // 解决轮播loop问题导致的问题
  const swiperContent = () => {
    return (
      <React.Fragment>
        {store.versionList?.map((item, index) => {
          return (
            <div
              key={index}
              className={cx(styles.contentText, store.currentIndex === index && styles.contentTextActive)}
              style={{ paddingBottom: `${px2rem(store.vhOffset > 0 ? 360 + store.vhOffset : 360)}rem` }}
            >
              {store.currentIndex === index && (
                <div className={styles.titleBox}>
                  <div className={styles.titleTail}>
                    <div className={styles.tail_num}>0{index + 1}</div>
                    <div className={styles.tail_id}>
                      {item.title}
                      <div className={styles.progressLine}>{store.currentIndex === index && <div className={cx(styles.progress)} />}</div>
                    </div>
                  </div>

                  <div className={styles.tips}>
                    {index + 1}
                    /
                    {store.versionList.length}
                    <span className={styles.square} />
                  </div>
                </div>
              )}
              {store.currentIndex === index && (
                <div className={styles.textBox}>
                  <div className={styles.textInfo}>
                    <div className={styles.infoItem}>{item.info[0]}</div>
                    <div className={styles.infoItem}>{item.info[1]}</div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <div className={cx(styles.thirdSectionRoot, store.isActive && styles.rootActive)}>
      <div className={styles.versionSwiper}>
        <BaseSwiper store={store.versionSwiper}>
          {store.versionList?.map((item, index) => {
            return (
              <div className={cx(styles.versionItem)} key={index}>
                <div
                  className={cx(styles.versionImgs)}
                  style={{
                    backgroundImage: `url(${item.bgImgs && item.bgImgs})`
                  }}
                />
              </div>
            );
          })}
        </BaseSwiper>
        {swiperContent()}
        <Link
          className={styles.prevBtn}
          onClick={store.versionTabSwiper.goPrev}
          style={{ bottom: `${px2rem(store.vhOffset > 0 ? 140 + store.vhOffset : 140)}rem` }}
        />
        <Link
          className={styles.nextBtn}
          onClick={store.versionTabSwiper.goNext}
          style={{ bottom: `${px2rem(store.vhOffset > 0 ? 140 + store.vhOffset : 140)}rem` }}
        />
        <div className={styles.tabSwiper} style={{ bottom: `${px2rem(store.vhOffset > 0 ? 120 + store.vhOffset : 120)}rem` }}>
          <BaseSwiper store={store.versionTabSwiper}>
            {store.versionList?.map((item, index) => {
              return (
                <div className={cx('tabItem')} key={index}>
                  <div className={cx('tabItemInner')}>
                    <div className={cx('itemCoverImg')} style={{ backgroundImage: `url(${item.tabCoverImgs && item.tabCoverImgs})` }} />
                    <div className={'mask'} />
                    <div className={'tab_icon'} />
                    <div className={'progress_line'} />
                    <div className={'tabNum'}>
                      <span>[0{index + 1}.</span>
                      {item.title}]
                    </div>
                  </div>
                </div>
              );
            })}
          </BaseSwiper>
        </div>
        <div className={styles.pagination} style={{ bottom: `${px2rem(store.vhOffset > 0 ? 60 + store.vhOffset : 60)}rem` }}>
          {store.versionList?.map((item, index) => {
            return <div key={index} onClick={() => { }} className={cx(styles.slick, store.currentIndex === index && styles.slick_active)} />;
          })}
          <div className={styles.count}>
            {store.currentIndex + 1}/{store.versionList?.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(ThirdSection, ThirdSectionStore);
